import {makeTrackEvent} from './makeTrackEvent';

export type PanelBankSectionAction = 'custom grid' | 'standard grid';

export type PanelBankSectionEvent = {
  action: PanelBankSectionAction;
  numPanels?: number;
};

export const trackPanelBankSection = makeTrackEvent<
  PanelBankSectionEvent,
  {
    action: {
      description: 'the action that occurred';
    };
    numPanels: {
      description: 'how many panels are inside section';
    };
    _description: 'Track panel bank actions usage';
    _location: 'workspaces';
    _motivation: 'track UI usage';
  }
>('Panel bank section');
